interface CloseAndSaveButtonProps {
    onSaveAndFinishedAction: () => void;
}

export const CloseAndSaveButton = (props: CloseAndSaveButtonProps) => {
    return <div className={`data-panel__mainTest__nav__buttons__button close-and-save expand`} onClick={props.onSaveAndFinishedAction}>
        <span className="material-symbols-outlined">close</span>
        <span className="button-text">Zapisz i wyjdź</span>
    </div>
}